import { render } from "./LocaleChooser2.vue?vue&type=template&id=6252b22e&scoped=true"
import script from "./LocaleChooser2.vue?vue&type=script&lang=js"
export * from "./LocaleChooser2.vue?vue&type=script&lang=js"

import "./LocaleChooser2.vue?vue&type=style&index=0&id=6252b22e&lang=css"
import "./LocaleChooser2.vue?vue&type=style&index=1&id=6252b22e&scoped=true&lang=css"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6252b22e"]])

export default __exports__